import { useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { AuthContext } from '~contexts/auth';
import PromptService from '~services/prompt';

export const useLoginPrompt = () => {
  const { isAuthenticated, signIn } = useContext(AuthContext);
  const history = useHistory();
  const intl = useIntl();

  const showLoginPrompt = useCallback((options = {}) => {
    const {
      redirectUrl = '/intake/client',
      onConfirmed = () => {}
    } = options;

    if (!isAuthenticated) {
      return PromptService.confirm({
        title: intl.formatMessage({
          id: 'components.card.login-required.title',
          defaultMessage: 'You are not logged in'
        }),
        content: intl.formatMessage({
          id: 'components.card.login-required.message',
          defaultMessage: 'To be sure you only see the cleaners that want to work in your specific location please fill in your wishes and location.'
        }),
        ok: intl.formatMessage({
          id: 'components.card.login-required.find-help',
          defaultMessage: 'Find your help'
        }),
        cancel: intl.formatMessage({
          id: 'components.header.sign-in',
          defaultMessage: 'Login'
        }),
        className: 'c-modal--login-redirect-prompt',
        onCancel: () => signIn({ returnTo: window.location.pathname + window.location.search })
      }).then((confirmed) => {
        if (confirmed) {
          history.push(redirectUrl);
          onConfirmed(); // Run callback
        }
        return confirmed;
      });
    }

    return Promise.resolve(true);
  }, [isAuthenticated, history, intl, signIn]);

  return { showLoginPrompt };
};
